var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jumpwxapp"},[_c('a',{staticClass:"button",attrs:{"href":_vm.link}},[_vm._v("立即添加班主任")])])}
var staticRenderFns = []

export { render, staticRenderFns }